
<div class="min-h-screen flex flex-col">

  <div class="app-header bg-base-300 z-10">
    <nav class="bm-navbar bg-primary text-primary-content">
      <a class="navbar-brand" href="#" class="ml-4">
        <img src="assets/bentomax-x.svg" style="width: 30px" />
      </a>
      <!-- <button class="navbar-toggler" type="button" (click)="toggleNavbar()">
        <span class="navbar-toggler-icon"></span>
      </button> -->

      @if (isLoggedIn()) {
        <div class="mb-navbar-center flex-1 flex">
          <ul class="bm-menu bm-menu-horizontal flex-1 m-0 p-0">
            <li>
              <a routerLink="/dashboard/customer">Dashboard BI</a>
            </li>
            <li>
              <a routerLink="/ticket/suche/index">Tickets</a>
            </li>
            <li>
              <a routerLink="/ticket/neu">Ticketerstellung</a>
            </li>
            <li>
              <a routerLink="/qm/uebersicht">QM Übersicht</a>
            </li>
            <li>
              <a routerLink="/planning_assistant">Projektassistent</a>
            </li>
            <li>
              <a routerLink="/projekt">Projekteinstellungen</a>
            </li>
            <li>
              <a [cdkMenuTriggerFor]="tplLager"> Lager </a>
              <ng-template #tplLager>
                <ul
                  class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
                  cdkMenu
                >
                  <li><a cdkMenuItem routerLink="/lager/uebersicht">Lagerstandorte</a></li>
                  <li><a cdkMenuItem routerLink="/artikel/suche">Artikel finden</a></li>
                  <li><a cdkMenuItem routerLink="/lieferscheine/suche/index">Lieferscheine</a></li>
                  <li><a cdkMenuItem routerLink="/lager/erwartete-lieferungen">Erwartete Lieferungen</a></li>
                  <li><a cdkMenuItem routerLink="/pickpoint_stations">PickPoint-Stationen</a></li>
                  <li><a cdkMenuItem routerLink="/lager/ups-pickup-planung">UPS-Abholung</a></li>
                  <li><a cdkMenuItem routerLink="/artikelvorlagen/uebersicht">Artikelvorlagen</a></li>
                  <li><a cdkMenuItem routerLink="/lager/artikel_aufteilen">Artikel aufteilen</a></li>
                  <li><a cdkMenuItem routerLink="/lager/eingang">Erfassung Großlieferung</a></li>
                  <li>
                    <a cdkMenuItem routerLink="/lager/verarbeitung">Großlieferung weiterverarbeiten</a>
                  </li>
                </ul>
              </ng-template>
            </li>
            <li>
              <a routerLink="/kapazitaetsuebersicht">Kapazitätsübersicht</a>
            </li>
            <li>
              <a [cdkMenuTriggerFor]="tplAdmin"> Admin </a>
              <ng-template #tplAdmin>
                <ul
                  class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
                  cdkMenu
                >
                  <li><a cdkMenuItem routerLink="/benutzer">Benutzer</a></li>
                  <li><a cdkMenuItem routerLink="/kunde">Kunden</a></li>
                  <li><a cdkMenuItem routerLink="/filiale">Filialen</a></li>
                  <li><a cdkMenuItem routerLink="/projekt">Projekte</a></li>
                  <li><a cdkMenuItem routerLink="/admin/waagen">Waagen &amp; Eichämter</a></li>
                  <li><a cdkMenuItem routerLink="/admin/queue">Job Queue</a></li>
                  <li><a cdkMenuItem routerLink="/admin/sync-konflikte">Sync-Konflikte App</a></li>
                  <li><a cdkMenuItem href="/admin/user">Alte Adminseite</a></li>
                  <li><a cdkMenuItem routerLink="/ticket/fixer">Ticket Fixer</a></li>
                </ul>
              </ng-template>
            </li>
          </ul>
          <ul class="bm-menu bm-menu-horizontal m-0 p-0">
            <li>
              <a href="/account">Konto</a>
            </li>
            <li>
              <a href="" (click)="handleLogout()">Abmelden</a>
            </li>
          </ul>
        </div>
      }
    </nav>
  </div>

  <div class="app-content bg-base-200 px-4 z-1 flex-1">
    <router-outlet />
  </div>

  <footer class="app-footer bg-base-300">
    <div class="py-1 text-center opacity-50 text-xs">Made with <i class="fas fa-heart"></i> for Bentomax</div>
  </footer>

</div>
